import React, {useRef, useState} from 'react';
import './AppBody.css';
import './IntroPage.css';
import { IntroPage } from './IntroPage.js';
import { LeftFeature} from './LeftFeature.js';
import { RightFeature} from './RightFeature.js';
import { AboutUsPage } from './AboutUsPage.js';
import { FeaturesTitlePage } from './FeaturesTitlePage.js';
import ContactUsPage from './ContactUsPage.js';
import { Modal } from 'antd';

// Warning component to show on mobile/tablet devices
const AppBody = ({scrollToSection, isMobile}) => {

    const introRef = useRef(null);
    const aboutUsRef = useRef(null);
    const servicesRef = useRef(null);
    const contactRef = useRef(null);
    const courtReservationRef = useRef(null);
    const trournamentPlannerRef = useRef(null);
    const membershipManagementRef = useRef(null);
    const dashbordsRef = useRef(null);
    const notificationsRef = useRef(null);
    const studentProgressRef = useRef(null);
    const inventoryManagementRef = useRef(null);
    const inbuiltPosRef = useRef(null);

    const refs = {
        courtReservationRef,
        trournamentPlannerRef,
        membershipManagementRef,
        dashbordsRef,
        notificationsRef,
        studentProgressRef,
        inventoryManagementRef,
        inbuiltPosRef,
      };

    const [isContactModalVisible, setIsContactModalVisible] = useState(false);

    scrollToSection.current = (section) => {
      switch (section) {
          case 'Home':
              introRef.current?.scrollIntoView({ behavior: 'smooth' });
              break;
          case 'About':
              aboutUsRef.current?.scrollIntoView({ behavior: 'smooth' });
              break;
          case 'Services':
              servicesRef.current?.scrollIntoView({ behavior: 'smooth' });
              break;
          case 'Contact':
              setIsContactModalVisible(true);
              // contactRef.current?.scrollIntoView({ behavior: 'smooth' });
              break;
          case `${section}`:
              refs[section]?.current?.scrollIntoView({ behavior: 'smooth' });
              break;
          default:
              break;
      }
    };

    const handleModalClose = () => {
      setIsContactModalVisible(false);
    };

    const aboutUs2  = '/aboutus.png';
    const courtreservation = '/featurespics/courtreservation.png';
    const tournamentPlanner = '/featurespics/tournamentplanner.png';
    const membershipManagement = '/featurespics/membershipManagement.png';
    const realtimeDashboards = '/featurespics/Dashboards.png';
    const realtimeNotfications = '/featurespics/Notifications.png';
    const curriclumTrackerTool = '/featurespics/curriculumTracker.png';
    const inventoryManagement = '/featurespics/inventoryManagement.png';
    const inbuiltPos = '/featurespics/POS.png';

    const linDan = '/animepics/LinDan.png';
    const kentoMomota = '/animepics/kentomomota.png';
    const leeChongWei = '/animepics/leeChongWei.png';
    const peterHoegGade = '/animepics/PeterHoegGade.png';
    const sainaNehwal = '/animepics/SainaNehwal.png';
    const susiSunati = '/animepics/SusiSUnati.png';
    const taufikHidayat = '/animepics/TaufikHidayat.png';
    const victorAxelsen = '/animepics/VictorAxelsen.png';

    const tournamentPlannerFeatuers = [
        "Seamless Tournament Setup",
        "Integrated Notifications",
        "Comprehensive Dashboards",
        "Efficient Management"
      ];

    const onlineCourtBookingFeatures = [
        "Effortless Online Booking",
        "Full Control for Owners",
        "Accessible Anywhere",
        "Convenient and User-Friendly"
    ];

    const membershipManagementFeatures = [
        "Easy Member Tracking",
        "Subscription Management",
        "Automated Reminders",
        "Flexible Access Control",
        "Analytics and Reports",
        "Mobile and Web Accessibility"
      ];

      const realtimeDashboardsFeatures = [
        "Instant Data Updates",
        "Customizable Views",
        "Visual Insights",
        "Track Key Metrics",
        "Interactive Components",
        "Mobile-Responsive"
      ];

      const realtimeNotificationsFeatures = [
        "Instant Alerts",
        "Customizable Preferences",
        "Automated Reminders",
        "Personalized Messages",
        "Activity Tracking",
        "Multi-Device Support"
      ];

      const curriculumTrackerToolFeatures = [
        "Progress Monitoring",
        "Customizable Curriculum Paths",
        "Milestone Tracking",
        "Performance Insights",
        "Automated Notifications",
        "Accessible Across Devices"
      ];

      const inventoryManagementFeatures = [
        "Real-Time Stock Tracking",
        "Automated Reordering",
        "Detailed Item Records",
        "Centralized Management",
        "Insights and Reports",
        "Mobile and Web Access"
      ];

      const inbuiltPOSFeatures = [
        "Seamless Transactions",
        "Inventory Integration",
        "Multiple Payment Options",
        "Sales Analytics",
        "User-Friendly Interface",
        "Multi-Device Compatibility"
    ];

    return (
        <div>
            <div ref={introRef}>
              <IntroPage scrollToSection={scrollToSection} isMobile={isMobile}/>
            </div>
            <div ref={aboutUsRef}>
              <AboutUsPage scrollToSection={scrollToSection} isMobile={isMobile} />
            </div>
            <div ref={servicesRef}>
              <FeaturesTitlePage/>
              <div ref={courtReservationRef}>
                <RightFeature 
                  features={onlineCourtBookingFeatures}
                  animeSrc={linDan} 
                  animeQuote="To me, success is not about winning; it’s about growing and always challenging myself." 
                  animeName="Lin Dan"
                  imageSrc={courtreservation} title={'Online Court Reservation'} 
                  description={'Effortlessly manage court reservations with our online booking feature. Your customers can conveniently reserve courts through our platform, while you maintain full control over court availability. As the owner, you can easily update schedules, and modify or cancel reservations—all accessible from our mobile app or webpage.'} 
                  animation={'zoom-in'}
                  isMobile={isMobile}/>
              </div>
              <div ref={trournamentPlannerRef}>
                <LeftFeature                   
                  features={tournamentPlannerFeatuers}
                  animeSrc={kentoMomota} 
                  animeQuote="Even when I lose, I learn from my mistakes and work to become stronger." 
                  animeName="Kento Momota"
                  imageSrc={tournamentPlanner} title={'Tournament Planner'} 
                  description={'..........Your feature detail content here...'} 
                  animation={'fade-in'}
                  isMobile={isMobile}/>
              </div>
              <div ref={membershipManagementRef}>
                <RightFeature 
                  features={membershipManagementFeatures}
                  animeSrc={leeChongWei} 
                  animeQuote="I don’t want to be a legend. I just want to be myself." 
                  animeName="Lee Chong Wei"
                  imageSrc={membershipManagement} 
                  title={'Membership Management'} 
                  description={'22..........Your feature detail content here...'}  
                  animation={'fade-left'}
                  isMobile={isMobile}/>
              </div>
              <div ref={dashbordsRef}>
                <LeftFeature 
                  features={realtimeDashboardsFeatures}
                  animeSrc={peterHoegGade} 
                  animeQuote="In badminton, it’s not just about speed. It’s about patience, strategy, and using your head." 
                  animeName="Peter Hoeg Gade"
                  imageSrc={realtimeDashboards} 
                  title={'Realtime Dashboards'} 
                  description={'..........Your feature detail content here...'} 
                  animation={'fade-right'}
                  isMobile={isMobile}/>
              </div>
              <div ref={notificationsRef}>
                <RightFeature 
                  features={realtimeNotificationsFeatures}
                  animeSrc={victorAxelsen} 
                  animeQuote="Hard work beats talent when talent doesn’t work hard." 
                  animeName="Victor Axelsen"
                  imageSrc={realtimeNotfications} 
                  title={'Realtime Notifications'} 
                  description={'33..........Your feature detail content here...'} 
                  animation={'fade-in'}
                  isMobile={isMobile}/>
              </div>
              <div ref={studentProgressRef}>
                <LeftFeature 
                  features={curriculumTrackerToolFeatures}
                  animeSrc={sainaNehwal} 
                  animeQuote="I want to be the best, it’s not about the ranking, it’s about being consistent." 
                  animeName="Saina Nehwal"
                  imageSrc={curriclumTrackerTool} 
                  title={'Curriculum Tracker Tool'} 
                  description={'..........Your feature detail content here...'} 
                  animation={'fade-down'} 
                  isMobile={isMobile}/>
              </div>
              <div ref={inventoryManagementRef}>
                <RightFeature 
                  features={inventoryManagementFeatures}
                  animeSrc={susiSunati} 
                  animeQuote="Success is not a matter of luck, but of hard work, dedication, and strong will." 
                  animeName="Susi Sunati"
                  imageSrc={inventoryManagement} 
                  title={'Inventory management'} 
                  description={'33..........Your feature detail content here...'} 
                  animation={'fade-in'}
                  isMobile={isMobile}/>
              </div>
              <div ref={inbuiltPosRef}>
                <LeftFeature 
                  features={inbuiltPOSFeatures}
                  animeSrc={taufikHidayat} 
                    animeQuote="If you want to be the best, you have to be willing to do what others are not willing to do." 
                  animeName="Taufik Hidayat"
                  imageSrc={inbuiltPos} 
                  title={'Inbuilt POS'} 
                    description={'..........Your feature detail content here...'} 
                    animation={'fade-down'}
                    isMobile={isMobile}/>
              </div>
            </div>

            {/* Contact Us Modal */}
              <Modal
                title={`${isMobile ? "Contact Us" : ""}`}
                visible={isContactModalVisible}
                onCancel={handleModalClose}
                footer={null}
                width={isMobile ? "80%" : "60%"}
                centered
              >
                <ContactUsPage />
              </Modal>
        </div>
    );
};

export default AppBody;